// User-facing organization types (excludes 'admin')
export type OrganizationType = 'tpa' | 'broker' | 'employer';

// Full organization type including internal 'admin' type
export type OrganizationTypeInternal = OrganizationType | 'admin';

export interface Organization {
  id: string;
  name: string;
  organization_type: OrganizationTypeInternal;
  created_at?: string;
  updated_at?: string;
}

export interface NewOrganization {
  name: string;
  organization_type: OrganizationType; // Only allows user-facing types
}

// Type guard to check if org is Kyndly (protected)
export const isKyndlyOrg = (org: Organization): boolean =>
  org.organization_type === 'admin';

// User-facing type labels for dropdown
export const ORGANIZATION_TYPE_LABELS: Record<OrganizationType, string> = {
  tpa: 'TPA',
  broker: 'Broker',
  employer: 'Employer'
};

// Type badge colors for UI
export const ORGANIZATION_TYPE_COLORS: Record<OrganizationTypeInternal, { bg: string; text: string }> = {
  admin: { bg: 'bg-gray-100 dark:bg-gray-900/30', text: 'text-gray-800 dark:text-gray-400' },
  tpa: { bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-800 dark:text-purple-400' },
  broker: { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-800 dark:text-green-400' },
  employer: { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-800 dark:text-blue-400' }
};

// Display label for all types (including admin for display purposes)
export const getOrganizationTypeLabel = (type: OrganizationTypeInternal): string => {
  if (type === 'admin') return 'Kyndly';
  return ORGANIZATION_TYPE_LABELS[type as OrganizationType];
};
